import React, { useCallback, useState , useEffect  } from "react";
import PageHeader from '../../components/Layout/PageHeader';
import { useParams,useNavigate } from 'react-router-dom';
import config from "../../constant/config";
import swal from 'sweetalert';
import Dropdown from 'react-dropdown';
import ReactSlider from "react-slider"
import DataTable , {createTheme} from 'react-data-table-component';
import Card from '../../components/Cards/Card.js';
import { ThemeContext } from '../../components/Layout/ThemeContext';


const axios = require('axios').default;


const FilterDataDashboard = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [isLoaded, setIsLoaded] = useState(false);
  const optionsFactor = [
    'X1', 'X2', 'X3','X4','X5','X6','X7','X8','X9'
  ];
  const optionsFactorPercent = [
    { value: '0', label: '0-10' },
    { value: '10', label: '10-20' },
    { value: '20', label: '20-30' },
    { value: '30', label: '30-40' },
    { value: '40', label: '40-50' },
    { value: '50', label: '50-60' },
    { value: '60', label: '60-70' },
    { value: '70', label: '70-80' },
    { value: '80', label: '80-90' },
    { value: '90', label: '90-100' }
  ];
  //const [casualFactorPostArray, setCasualFactorPostArray] = useState([]);
  const [casualFactor1, setCasualFactor1] = useState("Select Factor");
  const [casualFactor1Error, setCasualFactor1Error] = useState("");
  const [casualFactor1ErrorText, setCasualFactor1ErrorText] = useState("");
  const [casualFactor2, setCasualFactor2] = useState("Select Factor");
  const [casualFactor2Error, setCasualFactor2Error] = useState("");
  const [casualFactor2ErrorText, setCasualFactor2ErrorText] = useState("");
  const [casualFactor3, setCasualFactor3] = useState("Select Factor");
  const [casualFactor3Error, setCasualFactor3Error] = useState("");
  const [casualFactor3ErrorText, setCasualFactor3ErrorText] = useState("");
  const [casualFactor4, setCasualFactor4] = useState("Select Factor");
  const [casualFactor4Error, setCasualFactor4Error] = useState("");
  const [casualFactor4ErrorText, setCasualFactor4ErrorText] = useState("");
  const [casualFactor5, setCasualFactor5] = useState("Select Factor");
  const [casualFactor5Error, setCasualFactor5Error] = useState("");
  const [casualFactor5ErrorText, setCasualFactor5ErrorText] = useState("");
  const [casualFactor6, setCasualFactor6] = useState("Select Factor");
  const [casualFactor6Error, setCasualFactor6Error] = useState("");
  const [casualFactor6ErrorText, setCasualFactor6ErrorText] = useState("");
  const [casualFactor7, setCasualFactor7] = useState("Select Factor");
  const [casualFactor7Error, setCasualFactor7Error] = useState("");
  const [casualFactor7ErrorText, setCasualFactor7ErrorText] = useState("");
  const [casualFactor8, setCasualFactor8] = useState("Select Factor");
  const [casualFactor8Error, setCasualFactor8Error] = useState("");
  const [casualFactor8ErrorText, setCasualFactor8ErrorText] = useState("");
  const [casualFactor9, setCasualFactor9] = useState("Select Factor");
  const [casualFactor9Error, setCasualFactor9Error] = useState("");
  const [casualFactor9ErrorText, setCasualFactor9ErrorText] = useState("");
  const [casualFactor10, setCasualFactor10] = useState("Select Factor");
  const [casualFactor10Error, setCasualFactor10Error] = useState("");
  const [casualFactor10ErrorText, setCasualFactor10ErrorText] = useState("");
  const [casualFactor11, setCasualFactor11] = useState("Select Factor");
  const [casualFactor11Error, setCasualFactor11Error] = useState("");
  const [casualFactor11ErrorText, setCasualFactor11ErrorText] = useState("");
  const [casualFactor12, setCasualFactor12] = useState("Select Factor");
  const [casualFactor12Error, setCasualFactor12Error] = useState("");
  const [casualFactor12ErrorText, setCasualFactor12ErrorText] = useState("");
  const [casualFactor13, setCasualFactor13] = useState(0);
  const [casualFactor13Error, setCasualFactor13Error] = useState("");
  const [casualFactor13ErrorText, setCasualFactor13ErrorText] = useState("");
  const [casualFactor14, setCasualFactor14] = useState(0);
  const [casualFactor14Error, setCasualFactor14Error] = useState("");
  const [casualFactor14ErrorText, setCasualFactor14ErrorText] = useState("");
  const [casualFactor15, setCasualFactor15] = useState(0);
  const [casualFactor15Error, setCasualFactor15Error] = useState("");
  const [casualFactor15ErrorText, setCasualFactor15ErrorText] = useState("");
  const [casualFactor16, setCasualFactor16] = useState(0);
  const [casualFactor16Error, setCasualFactor16Error] = useState("");
  const [casualFactor16ErrorText, setCasualFactor16ErrorText] = useState("");

  const { theme, setTheme } = React.useContext(ThemeContext);
  const { themeBgColor, setThemeBgColor } = useState("#ffffff");
  const { themeTextColor, setThemeTextColor } = useState("#000000");
  const [tableData, setTableData] = useState([]);

  
  useEffect(() => {
    //filterDataDashboard();
  }, []);

  const columns = [
    {
        name: 'C.F. 1',
        selector: row => row.casual_factor1,
        sortable: true,
    },
    {
      name: 'C.F. 2',
      selector: row => row.casual_factor2,
      sortable: true,
    },
    {
      name: 'C.F. 3',
      selector: row => row.casual_factor3,
      sortable: true,
    },
    {
      name: 'C.F. 4',
      selector: row => row.casual_factor4,
      sortable: true,
    },
    {
      name: 'C.F. 5',
      selector: row => row.casual_factor5,
      sortable: true,
    },
    {
      name: 'C.F. 6',
      selector: row => row.casual_factor6,
      sortable: true,
    },
    {
      name: 'C.F. 7',
      selector: row => row.casual_factor7,
      sortable: true,
    },
    {
      name: 'C.F. 8',
      selector: row => row.casual_factor8,
      sortable: true,
    },
    {
      name: 'C.F. 9',
      selector: row => row.casual_factor9,
      sortable: true,
    },
    {
      name: 'C.F. 10',
      selector: row => row.casual_factor10,
      sortable: true,
    },
    {
      name: 'C.F. 11',
      selector: row => row.casual_factor11,
      sortable: true,
    },
    {
      name: 'C.F. 12',
      selector: row => row.casual_factor12,
      sortable: true,
    },
    {
      name: 'C.F. 13',
      selector: row => row.casual_factor13,
      sortable: true,
    },
    {
      name: 'C.F. 14',
      selector: row => row.casual_factor14,
      sortable: true,
    },
    {
      name: 'C.F. 15',
      selector: row => row.casual_factor15,
      sortable: true,
    },
    {
      name: 'C.F. 16',
      selector: row => row.casual_factor16,
      sortable: true,
    }
  ];
  
   let lang = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of"
  };

  createTheme(
    'dark',
    {
      text: {
        primary: themeTextColor,
        secondary: themeTextColor,
      },
      background: {
        default: themeBgColor,
      },
      context: {
        background: '#cb4b16',
        text: '#FFFFFF',
      },
      divider: {
        default: '#073642',
      },
      button: {
        default: '#2aa198',
        hover: 'rgba(0,0,0,.08)',
        focus: 'rgba(255,255,255,.12)',
        disabled: 'rgba(255, 255, 255, .34)',
      },
      sortFocus: {
        default: '#2aa198',
      },
    },
    'dark',
  );

  const filterDataDashboard = () => {
    console.log('Run');
    let casualFactorPostArray={};
    if(casualFactor1!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor1':casualFactor1})
    }
    if(casualFactor2!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor2':casualFactor2})
    }
    if(casualFactor3!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor3':casualFactor3})
    }
    if(casualFactor4!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor4':casualFactor4})
    }
    if(casualFactor5!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor5':casualFactor5})
    }
    if(casualFactor6!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor6':casualFactor6})
    }
    if(casualFactor7!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor7':casualFactor7})
    }
    if(casualFactor8!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor8':casualFactor8})
    }
    if(casualFactor9!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor9':casualFactor9})
    }
    if(casualFactor10!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor10':casualFactor10})
    }
    if(casualFactor11!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor11':casualFactor11})
    }
    if(casualFactor12!='Select Factor')
    {
      Object.assign(casualFactorPostArray, {'casual_factor12':casualFactor12})
    }
    if(casualFactor13>0)
    {
      Object.assign(casualFactorPostArray, {'casual_factor13':casualFactor13})
    }
    if(casualFactor14>0)
    {
      Object.assign(casualFactorPostArray, {'casual_factor14':casualFactor14})
    }
    if(casualFactor15>0)
    {
      Object.assign(casualFactorPostArray, {'casual_factor15':casualFactor15})
    }
    if(casualFactor16>0)
    {
      Object.assign(casualFactorPostArray, {'casual_factor16':casualFactor16})
    }
    
    console.log(casualFactorPostArray);
    axios.post(`${config.baseUrl}/api/casualfactors`,casualFactorPostArray)
    .then(function (response) {
      setTableData([]);
      console.log(response.data);
      setTableData(response.data);
    })
    .catch(function (error) {
      console.log(error);
      //console.log(error.response.data);
      //swal("Oh noes!", error.response.data, "error");
    });
  };

  return (
    <main className='flex-1'>
      <PageHeader title={'Filter Casual Factor'} showCreateButton={false}/>
      <div className='px-4 mt-6 sm:px-6 lg:px-8 '>
        <div className="lg:flex mt-3">
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 1</span>
              <Dropdown options={optionsFactor} placeholder="Select an option" onChange={(value) => setCasualFactor1(value.value)} value={casualFactor1} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor1Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor1ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 2</span>
              <Dropdown options={optionsFactor} placeholder="Select an option" onChange={(value) => setCasualFactor2(value.value)} value={casualFactor2} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor2Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor2ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 3</span>
              <Dropdown options={optionsFactor} placeholder="Select an option" onChange={(value) => setCasualFactor3(value.value)} value={casualFactor3} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor3Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor3ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 4</span>
              <Dropdown options={optionsFactor} placeholder="Select an option" onChange={(value) => setCasualFactor4(value.value)} value={casualFactor4} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor4Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor4ErrorText}
              </p>
            </label>
          </div>
        </div>
      </div>

      <div className='px-4 mt-6 sm:px-6 lg:px-8 '>
        <div className="lg:flex mt-3">
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 5</span>
              <Dropdown options={optionsFactor} placeholder="Select an option" onChange={(value) => setCasualFactor5(value.value)} value={casualFactor5} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor5Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor5ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 6</span>
              <Dropdown options={optionsFactor} placeholder="Select an option" onChange={(value) => setCasualFactor6(value.value)} value={casualFactor6} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor6Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor6ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 7</span>
              <Dropdown options={optionsFactorPercent} placeholder="Select an option" onChange={(value) => setCasualFactor7(value.value)} value={casualFactor7} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor7Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor7ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 8</span>
              <Dropdown options={optionsFactorPercent} placeholder="Select an option" onChange={(value) => setCasualFactor8(value.value)} value={casualFactor8} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor8Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor8ErrorText}
              </p>
            </label>
          </div>
        </div>
      </div>

      <div className='px-4 mt-6 sm:px-6 lg:px-8 '>
        <div className="lg:flex mt-3">
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 9</span>
              <Dropdown options={optionsFactorPercent} placeholder="Select an option" onChange={(value) => setCasualFactor9(value.value)} value={casualFactor9} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor9Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor9ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 10</span>
              <Dropdown options={optionsFactorPercent} placeholder="Select an option" onChange={(value) => setCasualFactor10(value.value)} value={casualFactor10} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor10Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor10ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 11</span>
              <Dropdown options={optionsFactorPercent} placeholder="Select an option" onChange={(value) => setCasualFactor11(value.value)} value={casualFactor11} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor11Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor11ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 12</span>
              <Dropdown options={optionsFactorPercent} placeholder="Select an option" onChange={(value) => setCasualFactor12(value.value)} value={casualFactor12} className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor12Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor12ErrorText}
              </p>
            </label>
          </div>
        </div>
      </div>

      <div className='px-4 mt-6 sm:px-6 lg:px-8 '>
        <div className="lg:flex mt-3">
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <label for="minmax-range" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Causal Factor 13</label>
              <ReactSlider
                step={1}
                min={0}
                max={75}
                className="w-full h-3 pr-2 my-4 bg-gray-200 rounded-md cursor-grab"
                thumbClassName="absolute w-5 h-5 cursor-grab bg-indigo-500 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 -top-2px"
                value={casualFactor13}
                onChange={(value) => {
                  setCasualFactor13(value)
                }}
              />
              <p class={casualFactor13Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor13ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
            <label for="minmax-range" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Causal Factor 14</label>
              <ReactSlider
                step={1}
                min={0}
                max={75}
                className="w-full h-3 pr-2 my-4 bg-gray-200 rounded-md cursor-grab"
                thumbClassName="absolute w-5 h-5 cursor-grab bg-indigo-500 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 -top-2px"
                value={casualFactor14}
                onChange={(value) => {
                  setCasualFactor14(value)
                }}
              />
              <p class={casualFactor13Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor13ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 15</span>
              <input type="text" value={casualFactor15} onChange={(event) => {setCasualFactor15(event.target.value)}} class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor15Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor15ErrorText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/4">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Causal Factor 16</span>
              <input type="text" value={casualFactor16} onChange={(event) => {setCasualFactor16(event.target.value)}} class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={casualFactor16Error +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {casualFactor16ErrorText}
              </p>
            </label>
          </div>
        </div>
        <div class="relative rounded-xl overflow-auto p-8">
          <div class="grid place-items-center">
            <button onClick={() => filterDataDashboard()} class="bg-sky-500 hover:bg-sky-700 px-5 py-2 text-sm leading-5 rounded-full font-semibold text-white">
              Search
            </button>
          </div>
        </div>
      </div>

      <Card>
          <DataTable
            class="dark:bg-slate-800"
            title="Casual Factor Details"
            columns={columns}
            data={tableData}
            theme={theme}
            defaultSortField="title"
            pagination
            paginationComponentOptions={{
              rowsPerPageText: lang.rowsPerPageText,
              rangeSeparatorText: lang.rangeSeparatorText,
              noRowsPerPage: false
            }}
          />
        </Card>
    </main>
  );
};

export default FilterDataDashboard;

